module.exports = __webpack_public_path__ + "img/rebuild_liao_pc2.56e85bb7.jpg";